<template>
  <AnkleBootsCollectionPage />
</template>

<script setup lang="ts">
import AnkleBootsCollectionPage from '../../ankle-boots/index.vue'
</script>
